import axios from "../../config/axiosConfig";
import { API } from "../../config/constant";

const { BOOK_PACKAGES } = API;

export const getBookPackages = async (body) => {
  return await axios.post(BOOK_PACKAGES,body)
    .then((res) => res)
    .catch((err) => err);
};